import moment from "moment";
import { BaseEntity, getCachedRegionEntity } from ".";
import { IGet_markets_region_id_history_200_ok } from "../service/esiclient";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class MarketHistoryEntity extends BaseEntity {
  private _regionID: number;
  constructor(id: number, regionid: number, props: any) {
    super(id, props);
    this._regionID = regionid;
    this._dataTypeName = "Market history data";
  }

  async toJson(): Promise<Excel.EntityCellValue> {
    const id = this._id;
    const regionid = this._regionID;
    const props: Partial<IGet_markets_region_id_history_200_ok[]> = this.props;

    var entity = await super.toJson();

    // Properties
    if (entity.properties) {
      const typeEntity = await getCachedTypeEntity(id);
      const regionEntity = await getCachedRegionEntity(regionid);
      entity.properties["region_id"] = {
        type: Excel.CellValueType.double,
        basicValue: regionid,
      };
      entity.properties["type_id"] = {
        type: Excel.CellValueType.double,
        basicValue: id,
      };
      if (typeEntity !== null && regionEntity !== null) {
        const entityName = typeEntity.props.name;
        const regionName = regionEntity.props.name;
        entity.text = "Market history for " + entityName + " in " + regionName;
      } else {
        entity.text = "Market history for " + id + " in " + regionid;
      }
      if (props) {
        let data_array: Excel.CellValue[][] = [];
        let props_sorted_by_date = props.sort((a, b) => moment(a?.date).unix() - moment(b?.date).unix());
        const dates = props_sorted_by_date.reverse();
        for (const y of dates) {
          if (y) {
            const date = moment(y.date);
            const simpleDate =
              y.date.getUTCDate() +
              "-" +
              (parseInt(y.date.getUTCMonth().toFixed(0)) + 1) +
              "-" +
              y.date.getUTCFullYear();
            data_array.push([
              {
                type: Excel.CellValueType.entity,
                text: simpleDate, //`${date.format("DD-MM-YYYY")}`,
                properties: {
                  date: {
                    type: Excel.CellValueType.formattedNumber,
                    basicValue: date.unix() / 86400 + 25569,
                    numberFormat: "[$-409]m/d/yy h:mm AM/PM;@",
                  },
                  average: {
                    type: Excel.CellValueType.double,
                    basicValue: y.average,
                  },
                  highest: {
                    type: Excel.CellValueType.double,
                    basicValue: y.highest,
                  },
                  lowest: {
                    type: Excel.CellValueType.double,
                    basicValue: y.lowest,
                  },
                  order_count: {
                    type: Excel.CellValueType.double,
                    basicValue: y.order_count,
                  },
                  volume: {
                    type: Excel.CellValueType.double,
                    basicValue: y.volume,
                  },
                },
              },
            ]);
          }
        }
        if (data_array.length) {
          entity.properties["history"] = {
            type: Excel.CellValueType.array,
            elements: data_array,
          };
        }
      }
    }

    // Layouts
    entity.layouts = {
      card: {
        //title: { property: "name" },
      },
    };

    return entity;
  }
}
